export default {
path: '/reports/specialist-schedule-report',
    component: () =>
      import('@/views/general-reports/specialist-schedule/Wrapper.vue'),
    children: [
      {
        path: '',
        name: 'SpecialistCalendarReport',
        component: () =>
          import('@/views/general-reports/specialist-schedule/Main.vue'),
      },
    ],
  }